import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonaDto } from 'src/app/dto/persona-dto';
import { LoginService } from 'src/app/services/login.service';
import { PersonaService } from 'src/app/services/persona.service';
import { UaaService } from 'src/app/services/uaa.service';
import { ReporteDialogComponent } from './reporte-dialog/reporte-dialog.component';

@Component({
  selector: 'app-par',
  templateUrl: './par.component.html',
  styleUrls: ['./par.component.css']
})
export class ParComponent implements OnInit {

  data: PersonaDto = new PersonaDto;
  grupo: any[] = [];
  url: String = 'https://gaitana.usco.edu.co/evadoc';

  constructor(
    private router: Router,
    private loginService: LoginService,
    public dialog: MatDialog,
    private personaService: PersonaService,
    private rutaActiva: ActivatedRoute,
    private uaaService: UaaService
  ) { }

  ngOnInit(): void {
    this.datosPersonales();
    this.obtenerGrupo();
  }

  setValues(periodo: number, personaCodigo: number, periodoNombre: string) {
    this.uaaService.setVariable('uaa', this.rutaActiva.snapshot.params.uaa);
    this.uaaService.setVariable('periodo', periodo);
    this.uaaService.setVariable('personaCodigo', personaCodigo);
    this.uaaService.setVariable('periodoNombre', periodoNombre);
  }

  onClickCerrarSesion() {
    this.uaaService.reset();  // limpiar estado en memoria
    this.loginService.logout(); // limpia storage y navega al login
  }

  datosPersonales() {
    this.personaService.datosPersonales().subscribe(data => {
      this.data = data;
      if (this.data.periodo && this.data.periodo.codigo) {
        this.personaService.getPeriodo(this.data.periodo.codigo).subscribe(nombre => {
          this.data.periodo.nombre = nombre;
          this.setValues(data.periodo.codigo, data.persona.codigo, nombre);
        });
      } else {
        this.setValues(data.periodo.codigo, data.persona.codigo, data.periodo.nombre);
      }
    })
  }

  obtenerGrupo() {
    this.personaService.ObtenerUid().subscribe(res => {
      this.grupo = res;
    }, (err: HttpErrorResponse) => console.log('error'));
  }

  reporte() {
    this.abrirReporteDialog('pares');
  }

  reporteObservaciones() {
    this.abrirReporteDialog('observaciones');
  }

  private abrirReporteDialog(tipo: string) {
    let uaaCodigo = this.rutaActiva.snapshot.params.uaa;

    this.grupo.filter(data => data.uaa == uaaCodigo).forEach(nombre => {
      this.dialog.open(ReporteDialogComponent, {
        maxWidth: '100vw',
        disableClose: false,
        data: {
          uaa: uaaCodigo,
          uaaNombre: nombre.nombre_uaa,
          tipo: tipo
        }
      });
    });
  }

}
